export const CATEGORY_PATTERN = {
  SIDES: 'category_sides',
  BREAKFAST: 'category_breakfast'
}

export const CATEGORY_LABEL = {
  SIDES: 'Sides',
  BREAKFAST: 'Breakfast'
}
